import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import setShowPricing from "@insite/client-framework/Store/Context/Handlers/SetShowPricing";
import translate from "@insite/client-framework/Translate";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import { ClickablePresentationProps } from "@insite/mobius/Clickable";
import { IconPresentationProps } from "@insite/mobius/Icon";
import  { TypographyPresentationProps } from "@insite/mobius/Typography";
import React from "react";

/* Custom Code - Start */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Checkbox, { CheckboxProps } from "@insite/mobius/Checkbox/Checkbox";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
/* Custom Code - End */

interface OwnProps {
    extendedStyles?: ShowPricingToggleStyles;
}

export interface ShowPricingToggleStyles {
    toggleClickable?: ClickablePresentationProps;
    toggleIcon?: IconPresentationProps;
    toggleTypography?: TypographyPresentationProps;
    // Custom Code
    wrapper?: InjectableCss;
    checkbox?: CheckboxProps;
}

export const showPricingToggleStyles: ShowPricingToggleStyles = {
    checkbox: {
        variant: "toggle",
        labelPosition: "right",
        sizeVariant: "small",
    },
};

export const ShowPricingToggle = ({ extendedStyles }: OwnProps) => {
    const dispatch = useAppDispatch();
    const showPricing = useAppSelector(state => state.context.showPricing);
    const styles = useMergeStyles("showPricingToggleStyles", showPricingToggleStyles, extendedStyles);

    const clickShowPricingToggleHandler = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        event.preventDefault();
        dispatch(setShowPricing({ showPricing: !showPricing }));
    };

    return (
        <StyledWrapper {...styles.wrapper} className="show-pricing-toggle" /* Custom Code */>
            {/* Custom Code - Start */}
            <Checkbox
                {...styles.checkbox}
                checked={showPricing}
                onChange={clickShowPricingToggleHandler}
                data-test-selector={showPricing ? "NotShowPricing" : "ShowPricing"}
            >
                {translate("Show Pricing")}
            </Checkbox>
            {/* Custom Code - End */}
        </StyledWrapper>
    );
};

export default ShowPricingToggle;
